import { Button, Paper, Typography, Link } from '@mui/material';
import { Link as LinkRouter, Navigate, useSearchParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { LoadingButton } from '@mui/lab';

const RESTRICT_LOGIN = gql`
  mutation RestrictLogin($bundle: String!, $email: String!) {
    restrictLogin(email: $email, bundle: $bundle) {
      emailsHasBeenSent
    }
  }
`;

export default function AlreadyLoggedPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();

  const [restrict, { loading, data }] = useMutation<{
    restrictLogin: { emailsHasBeenSent: boolean };
  }>(RESTRICT_LOGIN, {
    variables: { email: params.get('email'), bundle: 'br.com.segware.mysecurity' },
  });

  if (data?.restrictLogin.emailsHasBeenSent) {
    return <Navigate to="/already-logged/sended" />;
  }

  return (
    <Paper square elevation={3} sx={{ p: 5 }}>
      <Typography variant="h6" sx={{ mb: 4 }}>
        {t(
          'already_logged:you_are_already_logged_in_to_another_device_would_you_like_to_log_out_of_it',
        )}
      </Typography>
      <Typography sx={{ mb: 4 }}>
        {t(
          'already_logged:we_will_send_you_an_email_with_a_confirmation_link_to_log_out_so_you_can_log_in_on_this_new_device',
        )}
      </Typography>
      <LoadingButton
        variant="contained"
        fullWidth
        sx={{ mb: 2 }}
        onClick={() => restrict()}
        {...{ loading }}
      >
        {t('_common:continue')}
      </LoadingButton>
      <Link to="/login" component={LinkRouter} sx={{ textDecoration: 'none' }}>
        <Button variant="outlined" fullWidth>
          {t('_common:cancel')}
        </Button>
      </Link>
    </Paper>
  );
}
